import { Observable, Observer, of } from 'rxjs';

import { ActionItem, ActionItemStyle } from '@stylehaven/components';
import { EMPTY_OBSERVER } from '../../../helpers';
import { RecordActionItem } from './record-action-item.class';

// Purpose: used in unit tests
export class NullActionItem extends RecordActionItem<null> {
    constructor(label: string | Observable<string>) {
        super(label);
    }

    public toActionItem(record: null): Observable<ActionItem | null>;
    public toActionItem(record: null, observer: Observer<any>): Observable<ActionItem | null>;
    public toActionItem(
        record: null,
        observer: Observer<any>,
        actionItemStyle: ActionItemStyle
    ): Observable<ActionItem | null>;

    public toActionItem(
        record: null,
        observer: Observer<any>,
        actionItemTemplate: Partial<ActionItem>
    ): Observable<ActionItem | null>;

    public toActionItem(
        record: null,
        observer: Observer<any> = EMPTY_OBSERVER,
        actionItemTemplate: ActionItemStyle | Partial<ActionItem> = ActionItemStyle.Primary
    ): Observable<ActionItem | null> {
        return of(null);
    }
}
